// extracted by mini-css-extract-plugin
export default {"tagList":"index__tagList--PHbWe","tagItem":"index__tagItem--f4Bws","clearfix":"index__clearfix--py42c"};